module.exports = __webpack_public_path__ + "static/media/promo-code-redeem-sample.d2ca6c58.png";